import { KNOBS, atDefaults, knobText } from './usePrefs.js';

export default function TypeBar({ prefs, setPrefs, reset }) {
  return (
    <div className="typebar">
      {KNOBS.map(k => (
        <label className="knob" key={k.key}>
          <span className="knob-label">{k.label}</span>
          <input
            type="range" className="knob-range" aria-label={k.label}
            min={k.min} max={k.max} step={k.step} value={prefs[k.key]}
            onChange={e => setPrefs({ [k.key]: Number(e.target.value) })}
          />
          <span className="knob-value">{knobText(k, prefs)}</span>
        </label>
      ))}
      <div className="spacer" />
      <button className={'knob-reset' + (atDefaults(prefs) ? ' is-hidden' : '')} onClick={reset}>Reset</button>
    </div>
  );
}
